/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DeleteDocumentTemplateInput = {
    clientMutationId: string;
    documentTemplateId: string;
    tenantId: string;
};
export type useDeleteDocumentTemplateMutationVariables = {
    input: DeleteDocumentTemplateInput;
};
export type useDeleteDocumentTemplateMutationResponse = {
    readonly deleteDocumentTemplate: {
        readonly errors: ReadonlyArray<{
            readonly code: string | null;
            readonly path: ReadonlyArray<string | null> | null;
            readonly message: string | null;
            readonly type: string | null;
        } | null> | null;
    } | null;
};
export type useDeleteDocumentTemplateMutation = {
    readonly response: useDeleteDocumentTemplateMutationResponse;
    readonly variables: useDeleteDocumentTemplateMutationVariables;
};



/*
mutation useDeleteDocumentTemplateMutation(
  $input: DeleteDocumentTemplateInput!
) {
  deleteDocumentTemplate(input: $input) {
    errors {
      code
      path
      message
      type
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeleteDocumentTemplatePayload",
            "kind": "LinkedField",
            "name": "deleteDocumentTemplate",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "InputError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useDeleteDocumentTemplateMutation",
            "selections": (v1 /*: any*/),
            "type": "RootMutationType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useDeleteDocumentTemplateMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "c4de0c5e4070562abd6e4b1e07d93486",
            "id": null,
            "metadata": {},
            "name": "useDeleteDocumentTemplateMutation",
            "operationKind": "mutation",
            "text": "mutation useDeleteDocumentTemplateMutation(\n  $input: DeleteDocumentTemplateInput!\n) {\n  deleteDocumentTemplate(input: $input) {\n    errors {\n      code\n      path\n      message\n      type\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '9ac20ad8daa0971e8bb9408627759156';
export default node;
